// getRandomUsername.js
'use strict';

const getRandomUsername = ({ paddingNumber = 0 } = {}) => {
  const adjective = adjectivePool[Math.floor(Math.random() * 26)];
  const name = namePool[Math.floor(Math.random() * 26)];
  const padding = Math.floor(Math.random() * Math.pow(10, paddingNumber));
  return `${adjective}${name}${padding}`
    .replace(/0*$/gi, '')
    .slice(0, 20)
    .toLowerCase();
};

const adjectivePool = [
  'forceful',
  'petty',
  'key',
  'accomplished',
  'dull',
  'ashamed',
  'noisy',
  'snarling',
  'sharp',
  'mealy',
  'green',
  'plaintive',
  'brown',
  'silky',
  'fancy',
  'inexperienced',
  'spicy',
  'defenseless',
  'extraneous',
  'baggy',
  'lone',
  'memorable',
  'austere',
  'submissive',
  'fine',
  'icky',
  'pastel',
  'animated',
  'rough',
  'quaint',
  'rash',
  'uncomfortable',
  'rosy',
  'runny',
  'simple',
  'pushy',
  'probable',
  'innocent',
  'weepy',
  'pale',
  'negligible',
  'next',
  'young',
  'quiet',
  'unimportant',
  'cloudy',
  'worrisome',
  'pleasant',
  'growing',
  'inconsequential',
  'quixotic',
  'realistic',
  'adept',
  'unique',
  'odd',
  'svelte',
  'knowing',
  'internal',
  'woeful',
  'sticky',
  'amazing',
  'these',
  'excellent',
  'stained',
  'muted',
  'courageous',
  'ecstatic',
  'small',
  'jolly',
  'dishonest',
  'bare',
  'political',
  'actual',
  'bouncy',
  'fond',
  'utter',
  'frizzy',
  'everlasting',
  'miserly',
  'worthless',
  'urban',
  'deep',
  'itchy',
  'ajar',
  'hefty',
  'handy',
  'vital',
  'messy',
  'tender',
  'wet',
  'alive',
  'rowdy',
  'nonstop',
  'leafy',
  'playful',
  'perky',
  'dense',
  'ornate',
  'fabulous',
  'serious',
];

const namePool = [
  'Hunter',
  'Demon',
  'Howler',
  'Rain',
  'Red',
  'Shadow',
  'Storm',
  'Beast',
  'Bane',
  'Digger',
  'Horrid',
  'Fang',
  'Claw',
  'Wolf',
  'Crescent',
  'Paw',
  'Lupus',
  'Fire',
  'Temptress',
  'Warrior',
  'Rage',
  'Thron',
  'Moon',
  'Lupe',
  'Vixen',
  'Omega',
  'Firehazard',
  'BurnToast',
  'Salamander',
  'Dragontongue',
  'Sunlapper',
  'Queereye',
  'Earthshaker',
  'JustTim',
  'Forger',
  'Summerwand',
  'Littlestar',
  'Treehugger',
  'Crocodile',
  'Magichands',
  'Hands',
  'Wolf',
  'Cow',
  'Crow',
  'Merlinus',
  'Troll',
  'Shakiraships',
  'Wingear',
  'Dancer',
  'Imp',
  'Potty',
  'TheCripple',
  'Mystic',
  'Dawg',
  'Shine',
  'Mage',
  'Cloud',
  'Siren',
  'Player',
  'Quack',
  'Beams',
  'Healer',
  'Wizard',
  'Wolf',
  'Yapper',
  'Witch',
  'Angel',
  'Gigolo',
  'Heartbreaker',
  'Flirt',
  'Vamp',
  'Killer',
  'Shaman',
  'Lupus',
  'Moon',
  'Dream',
  'Charmer',
  'Zonker',
];

export default getRandomUsername;
